import mondaySdk from "monday-sdk-js";
import jwt from "jsonwebtoken";

const monday = mondaySdk({ apiVersion: "2023-10" });

export interface JWTSessionToken {
    dat: {
        account_id: string;
        client_id: string;
        user_id: string;
        slug: string;
        app_id: string;
        install_id?: string;
        is_admin: boolean;
    };
}

export async function getSessionToken(): Promise<string> {
    const sessionToken = await monday.get("sessionToken");
    return sessionToken.data;
}

export async function getDecodedSessionToken(): Promise<JWTSessionToken> {
    const sessionToken = await getSessionToken();
    const decoded = jwt.decode(sessionToken) as JWTSessionToken;
    return decoded;
}

export default monday;
